import { Injectable } from '@angular/core';
import { FormaDePagamento } from '../models/forma-de-pagamento';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FormaDePagamentoService {
  constructor(private http: HttpClient) {}

  consultar(status = 1, taxaZero?, repasse?) {
    let parametros = new HttpParams().set('status', status.toString());

    if (taxaZero !== null && taxaZero !== undefined) {
      parametros = parametros.set('taxaZero', taxaZero);
    }

    if (repasse !== null && repasse !== undefined) {
      parametros = parametros.set('repasse', repasse);
    }

    return this.http.get<FormaDePagamento[]>(globals.apiUrl + '/api/FormaPag/Listar', { params: parametros });
  }

  consultarSemFinanciamentos(status = 1) {
    return this.http.get<FormaDePagamento[]>(globals.apiUrl + '/api/FormaPag/ListarSemFinanciamentos', {
      params: new HttpParams().set('status', status.toString())
    });
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/FormaPag/Buscar', { params: new HttpParams().set('id', id) });
  }

  salvar(formaDePagamento: FormaDePagamento) {
    return this.http.post(globals.apiUrl + '/api/FormaPag/Salvar', formaDePagamento, { responseType: 'text' });
  }

  bloquear(id) {
    return this.http.get(globals.apiUrl + '/api/FormaPag/Bloquear', { params: new HttpParams().set('id', id) });
  }

  // consultarPorCondicao(idCondicao) {
  //   return this.http.get<FormaDePagamento[]>(globals.apiUrl + '/api/FormaPag/ListarPorCondicao',
  //     { params: new HttpParams().set('idCondicao', idCondicao) });
  // }
}
